"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var GamepadContext_1 = require("../GamepadContext");
var ROUTES = ['search', 'board', 'discover', 'library', 'calendar', 'links', 'addons', 'settings'];
var useVerticalGamepadNavigation = function (_sectionRef, currentRoute) {
    var gamepad = (0, GamepadContext_1.useGamepad)();
    (0, react_1.useEffect)(function () {
        var navigate = function (direction) {
            var currentIndex = ROUTES.indexOf(currentRoute);
            if (currentIndex === -1)
                return;
            var nextIndex = currentIndex;
            if (direction === 'next')
                nextIndex = Math.min(currentIndex + 1, ROUTES.length - 1);
            if (direction === 'prev')
                nextIndex = Math.max(currentIndex - 1, 0);
            if (nextIndex !== currentIndex) {
                document.dispatchEvent(new KeyboardEvent('keydown', { key: String(nextIndex), code: "Digit".concat(nextIndex), bubbles: true }));
            }
        };
        gamepad === null || gamepad === void 0 ? void 0 : gamepad.on('buttonLT', currentRoute, function () { return navigate('prev'); });
        gamepad === null || gamepad === void 0 ? void 0 : gamepad.on('buttonRT', currentRoute, function () { return navigate('next'); });
        return function () {
            gamepad === null || gamepad === void 0 ? void 0 : gamepad.off('buttonLT', currentRoute);
            gamepad === null || gamepad === void 0 ? void 0 : gamepad.off('buttonRT', currentRoute);
        };
    }, [gamepad, currentRoute]);
};
exports.default = useVerticalGamepadNavigation;
